import { isInstanceId } from '@/lib/instance/instanceId'

/** Instance lookup for imperative services outside React. */
export function getInstanceIdFromUrl(): string | undefined {
  if (typeof window === 'undefined') return undefined
  const instanceId = /^\/i\/([^/]+)(?:\/|$)/.exec(window.location.pathname)?.[1]
  return isInstanceId(instanceId) ? instanceId : undefined
}
